import config from '../common/config';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Cell } from 'react-flexr';
import { SearchPanel, SearchGroup, Slider } from '../common/search';
import * as date from '../utils/date-fns';

import ProductCategory from '../common/product-category';
import Showcase from '../common/showcase';
import TagFilter from '../common/tagFilter';

import { fromJS } from 'immutable';

const DATA_DEFAULT = 5;
const DATA_MAX = 1000;
const DATA_ALL = 0;
const DATA_UNLIMITED = 1000;

const DEFAULT_PRICE = 100;
const UNLIMITED_PRICE = 275;

export function serialiseMbb(offer) {
  const tags = offer.get('tags') ? offer.get('tags').toJS() : [];
    const manualTags = offer.get('manualTags') ? Array.from(offer.get('manualTags')) : [];
    const mergedTags = tags.reduce((acc, tag) => {
      if(!acc.includes(tag)) {
        acc.push(tag);
      }
      return acc;
    }, manualTags || []).filter(Boolean);

  return fromJS({
    id: offer.get('_id'),

    provider: offer.get('provider'),
    product: offer.get('product'),
    // logo: `${config.path.images}/${offer.get('imageUrl')}`,
    logo:
      offer.getIn(['image', 'hash']) &&
      `${config.images}${offer.getIn(['image', 'hash'])}`,
    link: `/redirect/${offer.get('uuid')}`,

    tagline: offer.get('tagline'),
    expire: date.format(offer.get('expire'), 'D. MMM'),

    orderText: 'Bestil nu',

    details: [
      {
        value: offer.getIn(['price', 'startupFee']),
        label: 'Oprettelse',
        unit: 'kr.',
        labelAbove: true
      },
      {
        value: !offer.getIn(['network', 'data', 'amount']) ? 'Ubegrænset' : offer.getIn(['network', 'data', 'amount']),
        unit: !offer.getIn(['network', 'data', 'amount']) ? '' : offer.getIn(['network', 'data', 'unit']),
        label: 'Data',
        labelAbove: true
      },
      {
        value: offer.getIn(['network', 'download', 'amount']),
        label: 'Download',
        unit: offer.getIn(['network', 'download', 'unit']),
        labelAbove: true
      }
    ],

    // priceSixMonth: offer.getIn(['price', 'sixMonths']) ? {
    //   value: offer.getIn(['discount', 'sixMonths']) &&
    //   offer.getIn(['discount', 'sixMonths']) < offer.getIn(['price', 'sixMonths'])
    //     ? offer.getIn(['discount', 'sixMonths'])
    //     : offer.getIn(['price', 'sixMonths']),
    //   unit: 'kr.',
    //   label: 'pris 6 mdr.',
    //   old:
    //     offer.getIn(['discount', 'sixMonths']) &&
    //     offer.getIn(['discount', 'sixMonths']) < offer.getIn(['price', 'sixMonths'])
    //       ? offer.getIn(['price', 'sixMonths'])
    //       : null
    // } : null,

    price: {
      value: offer.getIn(['discount', 'monthly']) &&
      offer.getIn(['discount', 'monthly']) < offer.getIn(['price', 'monthly'])
        ? offer.getIn(['discount', 'monthly'])
        : offer.getIn(['price', 'monthly']),
      unit: 'kr.',
      label: 'Pris pr. md.',
      old:
        offer.getIn(['discount', 'monthly']) &&
        offer.getIn(['discount', 'monthly']) < offer.getIn(['price', 'monthly'])
          ? offer.getIn(['price', 'monthly'])
          : null
    },

    usps: []
      .concat(mergedTags, offer.get('services').toJS())
      .filter(Boolean),

    productDescription: offer.get('productDescription'),
    discountCode: offer.get('discountCode'),

    _raw: offer
  });
}

class Offers extends ProductCategory {
  static defaultProps = {
    category: 'mobileBroadband'
  };

  constructor(props) {
    super(props);

    this.state = this.mapPropsToState(props, {
      offerType: 'mobilt-bredbånd',
      ...this.state,
      sort: this.createSort({ 'price.monthly': 1, weight: -1 }),
      defaultFilters: { // FOR FILTERS_USED EPI
        data: null,
        price: null,
        tags: []
      },
      filters: {
        data: null,
        price: null,
        tags: [],
        ...(this.state.filters || {})
      }
    });
  }

  resetFilter() {
    const filters = {
      ...(this.state.filters || {}),
      data: null,
      price: null,
      tags: []
    };
    
    this.setState({
      filters,
      filter: this.createFilter(filters)
    });
  }

  createFilter(filters) {
    this.updateFiltersUsed(filters);
    return offers =>
      offers.filter(offer => {
        const tags = Array.from(offer.getIn(['_raw', 'tags']));
        const manualTags = Array.from(offer.getIn(['_raw', 'manualTags']) || []);
        const mergedTags = tags.reduce((acc, tag) => {
          if(!acc.includes(tag)) {
            acc.push(tag);
          }
          return acc;
        }, manualTags).filter(Boolean);
        const lowerCaseTags = mergedTags.map(i => i.toLowerCase());
        const services = Array.from(offer.getIn(['_raw', 'services']));
        const lowerCaseServices = services.map(i => i.toLowerCase());
        const filteredTags = filters.tags;
        const lowerCaseProvider = offer.get('provider').toLowerCase().trim().replace('-', ' ');

        for (let idx = 0; idx < filteredTags.length; idx++) {
          const tag = filteredTags[idx];
          if (
            !lowerCaseServices.includes(tag) &&
            !lowerCaseTags.includes(tag) && 
            !mergedTags.includes(tag) &&
            !services.includes(tag) &&
            tag.toLowerCase() !== lowerCaseProvider) {
            return false;
          }
        }
        if (filters.data !== null) {
          if (
            filters.data !== DATA_ALL &&
            offer.getIn(['_raw', 'network', 'data', 'amount']) < filters.data
          ) {
            return false;
          }
        }

        if (filters.price !== null) {
          if (
            filters.price !== UNLIMITED_PRICE &&
            offer.getIn(['_raw', 'price', 'monthly']) > filters.price
          ) {
            return false;
          }
        }

        return true;
      });
  }

  serialiseOffer(offer) {
    return serialiseMbb(offer);
  }

  createSearchDisplay(filters) {
    const display = [];

    if (filters.price) {
      display.push(`Maks pris ${filters.price} kr.`);
    }
    if (filters.data) {
      display.push(`${filters.data} gb`);
    }

    return display;
  }

  headlinePrice(price) {
    if (price) {
      if (price[0] == UNLIMITED_PRICE) {
        return 'Alle';
      } else {
        return `${parseInt(price[0])} kr.`;
      }
    }
    return '';
  }

  headlineData(data) {
    if (data) {
      const val = parseInt(data[0], 10);
      if (val === DATA_ALL) {
        return 'Alle';
      }
      if (val === DATA_UNLIMITED) {
        return `${DATA_MAX}+ GB`;
      }
      return `${val} GB`;
    }
    return '';
  }

  render() {
    const { offers, filter, filters, showcases } = this.state;
    // const { providers } = this.state.filters;

    // const isPalm = findMatch('palm');

    return (
      <Grid>
        <Cell size='3/12' portable='1/1'>
          <SearchPanel
            title={'Mobilt bredbånd'}
            filter={filter}
            results={offers}
            filterTexts={this.createSearchDisplay(filters)}
          >
            <SearchGroup>
              <Slider
                name='price'
                connect='lower'
                disconnected={filters.price === null}
                headline={[
                  'Pris (max pr. md.)',
                  val => (filters.price === null ? '' : this.headlinePrice(val))
                ]}
                units={['25 kr.', '250 kr. | Alle']}
                range={{
                  min: [25, 25],
                  '50%': [DEFAULT_PRICE, 25],
                  max: [UNLIMITED_PRICE]
                }}
                defaultStart={[filters.price || DEFAULT_PRICE]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>

            <SearchGroup>
              <Slider
                name='data'
                connect='lower'
                disconnected={filters.data === null}
                headline={[
                  'Data',
                  val => (filters.data === null ? '' : this.headlineData(val))
                ]}
                units={['Alle | 10 GB', `${DATA_MAX}+ GB`]}
                range={{
                  min: [DATA_ALL, 10],
                  '15%': [10, 40],
                  '30%': [50, 50],
                  '45%': [100, 100],
                  '60%': [300, 200],
                  '75%': [500, 500],
                  max: [DATA_UNLIMITED]
                }}
                defaultStart={[filters.data || DATA_DEFAULT]}
                onSlide={this.sliderOnChange}
              />
            </SearchGroup>
            <TagFilter
              headline={'Tags'}
              feed={this.state.feed}
              offerType={this.state.offerType}
              items={offers}
              filters={filters}
              checkboxOnChange={this.tagsOnChange}
            />
          </SearchPanel>
        </Cell>
        <Cell>
          <Showcase list={showcases} orderText='Bestil' site_id={this.state.siteId} feed={this.state.feed} url={this.state.url} filters_used={this.state.filtersUsed}/>
          {this.renderResults(null, this.resetFilter.bind(this))}
        </Cell>
      </Grid>
    );
  }
}

export default connect(({ mbb: { offers } }) => ({ offers }))(
  withRouter(Offers)
);
